<template>
	<div class="toupiao">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="tu1">
					<div class="tu2" v-for="(item,index) in jcList" :key="index">
						<img :src="defaultimg" width="100%" height="100px" />
						<span class="biaoti">{{item.title}}</span>
						<!-- <div>{{item.content}}</div> -->
						<div class="po">
							<div class="tp1">
								<div class="ps">
									<div class="beij" :style="{width:countpercent(item,item.agreeNum)}">{{item.agreeNum||0}}票</div>
								</div>
								<!-- <div class="zc" @click="vote(1,item.voteResult,item.id)">赞成</div> -->
							</div>
							<div class="tp2">
								<div class="ps1">
									<div class="beij1" :style="{width:countpercent(item,item.againstNum)}">{{item.againstNum||0}}票</div>
								</div>
								<!-- <div class="zc1" @click="vote(2,item.voteResult,item.id)">反对</div> -->
							</div>
							<div class="tp3">
								<div class="ps2">
									<div class="beij2" :style="{width:countpercent(item,item.waiverNum)}">{{item.waiverNum||0}}票</div>
								</div>
								<!-- <div class="zc2" @click="vote(3,item.voteResult,item.id)">弃权</div> -->
							</div>
						</div>
						<div class="btns">
							<img src="../../assets/wxzj/zc.png" @click="vote(1,item.voteResult,item.id)">
							<img src="../../assets/wxzj/fd.png" @click="vote(2,item.voteResult,item.id)">
							<img src="../../assets/wxzj/qq.png" @click="vote(3,item.voteResult,item.id)">
						</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				defaultimg: require("../../assets/icon/ld.png"),
				jcList: [],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum: 0,
				id:''
			}
		},
		computed: {
			...mapState(['userInfo', 'identity', 'houseId']),
		},
		mounted(e) {
			this.id = this.$route.query.id;
		},
		methods: {
			vote(voteResult,currentvote,id){
				console.log(voteResult,currentvote,id)
				if(currentvote=='未投票'){
					this.$axios.post('/api/v1/maintenance/vote',{
						voteId:id,
						voteResult:voteResult,
						voterName:this.userInfo.trueName,
						voterPhone:this.userInfo.phone
					}).then(res=>{
						this.$dialog({ message: '投票成功'}).then(() => {
							this.refreshing=true;
							this.onRefresh();
						});
					})
				}else{
					this.$dialog({ message: '您已投票给'+currentvote }).then(() => {
					});
				}
				
			},
			countpercent(item,num=0){
				var total=Number(item.agreeNum)+Number(item.againstNum)+Number(item.waiverNum);
				if(total){
					return parseInt(Number(num)/total*100)+'%'
				}else{
					return 0
				}
			},
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					this.pageNum = 0;
					// 清空列表数据
					this.jcList = [];
					this.refreshing = false;
				}
				if(this.id){
					this.$axios.get('/api/v1/maintenance/vote/'+this.id, {
					}).then(res => {
						this.jcList.push(res);
						this.loading = false;
						this.finished = true;
					});
				}else{
					this.$axios.get('/api/v1/maintenance/votes', {
						params: {
							pageNum: this.pageNum,
							pageSize: 15,
							houseId: this.houseId
						}
					}).then(res => {
						this.jcList.push(...res.data);
						this.pageNum++;
						this.loading = false;
						if (this.jcList.length >= res.total) {
							this.finished = true;
						}
					});
				}
				
			},
			handleClick(id, status) {
				this.$router.push({
					path: "/yzjc/jcdet",
					query: {
						id: id
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.btns{
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
		img{
			width: 30%;
		}
	}
	.tu1 {
		padding: 10px;
		overflow: hidden;
		.tu2 {
			width: 48%;
			padding-top: 5px;
			padding-left: 5px;
			padding-bottom: 5px;
			margin-bottom: 10px;
			box-shadow: 1px 1px 1px 1px #d7d7d7;
			border-radius: 4px;
			float: left;
			&:nth-child(odd){
				margin-right: 4%;
			}
			.biaoti {
				font-size: 14px;
				font-weight: 600;
				display: inline-block;
				padding-left: 5px;
				padding-bottom: 5px;
			}

			.tp1 {
				width: 100%;
				height: 15px;
				font-size: 10px;
				margin-bottom: 10px;
				display: flex;

				.ps {
					display: inline-block;
					// width: 80%;
					width: 90%;
					color: #666;
					border-radius: 5px;
					.beij {
						height: 100%;
						border-radius: 5px;
						line-height: 1.5;
						padding-left: 8px;
						background: -webkit-linear-gradient(left, #fdc900, #fe7400);
						word-break: keep-all;
					}
				}

				.zc {
					width: 20%;
					display: inline-block;
					color: #fe7400;
					font-weight: 600;
					cursor: pointer;
					text-align: center;
					font-size: 12px;
				}
			}

			.po {
				position: relative;
				color: white;
			}

			.tp2 {
				height: 15px;
				font-size: 10px;
				margin-bottom: 10px;
				display: flex;

				.ps1 {
					display: inline-block;
					width: 80%;
					border-radius: 5px;

					.beij1 {
						height: 100%;
						border-radius: 5px;
						padding-left: 8px;
						line-height: 1.5;
						color: #666;
						word-break: keep-all;
						background: -webkit-linear-gradient(left, #5cc9fe, #629dfc);
					}
				}

				.zc1 {
					width: 20%;
					display: inline-block;
					text-align: center;
					color: #629dfc;
					font-size: 12px;
					font-weight: 600;
					cursor: pointer;
				}
			}

			.tp3 {
				height: 15px;
				font-size: 10px;
				display: flex;

				.ps2 {
					display: inline-block;
					width: 80%;
					border-radius: 5px;

					.beij2 {
						height: 100%;
						border-radius: 5px;
						line-height: 1.5;
						padding-left: 8px;
						color: #666;
						word-break: keep-all;
						background: -webkit-linear-gradient(left, #cbcbcb, #9e9e9e);
					}
				}

				.zc2 {
					width: 20%;
					display: inline-block;
					text-align: center;
					color: #9e9e9e;
					font-weight: 600;
					cursor: pointer;
					font-size: 12px;
				}
			}
		}
	}
</style>
